import { useEffect, useState } from "react"
import { GetTournamentInfo } from "../repo/TournamentsRepo.js"

export default function TournamentInfoStandings({tournamentId}) {
  const [tournament, setTournament] = useState(null)
  const defaultBadgeThumb = "https://bolaodacopa.com/images/default_badge_thumb.png"

  useEffect(() => {
    async function fetchTournament() {
      try {
        const tournament = await GetTournamentInfo(tournamentId)
        setTournament(tournament["data"])
      } catch (error) {
        console.error('Error fetching tournament info:', error)
      }
    }

    if (tournamentId) {
      fetchTournament()
    }
  }, [tournamentId])

  if (!tournament) {
    return null
  }

  return (
    <div className="mb-4 bg-slate-100 p-2 rounded-lg">
      {tournament.standings && Object.entries(tournament.standings).map(([groupName, teams]) => (
        <div key={groupName} className="mb-4 p-4 bg-white rounded-lg">
          <h3 className="text-md font-semibold mb-2 text-center">{ groupName }</h3>
          <table className="w-full text-left border-collapse">
            <thead className="text-xs text-slate-700 bg-slate-100">
              <tr className="border-b">
                <th className="px-1 py-1 w-6">#</th>
                <th className="px-1 py-1">Equipe</th>
                <th className="px-1 py-1 text-center w-8">P</th>
                <th className="px-1 py-1 text-center w-8">J</th>
                <th className="px-1 py-1 text-center w-8">V</th>
                <th className="px-1 py-1 text-center w-8">E</th>
                <th className="px-1 py-1 text-center w-8">D</th>
                <th className="px-1 py-1 text-center w-8 hidden md:table-cell">GP</th>
                <th className="px-1 py-1 text-center w-8 hidden md:table-cell">GC</th>
                <th className="px-1 py-1 text-center w-8 hidden md:table-cell">SG</th>
                <th className="px-1 py-1 text-center w-8 table-cell md:hidden">G</th>
              </tr>
            </thead>
            <tbody className="text-xs text-slate-900">
              {teams.map((team, index) => (
                <tr key={team.team_id} className="border-b">
                  <td className={`px-1 py-1 w-6 text-center ${index < 2 ? "bg-blue-900 text-white" : ""} ${index === 2 ? "bg-red-800 text-white" : ""}`}>{ team.rank }</td>
                  <td className="px-1 py-1">
                    <div className="flex items-center gap-2">
                      <img src={team.team_badge ? team.team_badge : defaultBadgeThumb} alt={team.team_name} className="w-5" />
                      <span>{ team.team_name }</span>
                    </div>
                  </td>
                  <td className="px-1 py-1 text-center w-8">{ team.points }</td>
                  <td className="px-1 py-1 text-center w-8">{ team.played }</td>
                  <td className="px-1 py-1 text-center w-8">{ team.win }</td>
                  <td className="px-1 py-1 text-center w-8">{ team.draw }</td>
                  <td className="px-1 py-1 text-center w-8">{ team.lose }</td>
                  <td className="px-1 py-1 text-center w-8 hidden md:table-cell">{ team.goals_for }</td>
                  <td className="px-1 py-1 text-center w-8 hidden md:table-cell">{ team.goals_against }</td>
                  <td className="px-1 py-1 text-center w-8 hidden md:table-cell">{ team.goals_diff }</td>
                  <td className="px-1 py-1 text-center w-8 table-cell md:hidden">{ team.goals_for }:{ team.goals_against }</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  )
}
  